import { getModel } from '@sgdocs/client';
import { useQuery } from 'react-query';
import { getToken } from './getToken';
import { throwOnUnauthorized } from './throwOnUnauthorized';

type TechnicalParams = {
  sgmDocsBaseUrl: string;
  token: string | null;
  enableQuery?: boolean;
  component: string;
};
type ApiParams = {
  workspaceId: string;
  modelId?: string;
};
export function useQueryGetModel(
  { workspaceId, modelId }: ApiParams,
  { sgmDocsBaseUrl, token, enableQuery, component }: TechnicalParams
) {
  const tokenUsed = getToken(token);
  return useQuery(
    `model-workspace-${workspaceId}-model-${modelId}`,
    () =>
      throwOnUnauthorized(
        getModel({ workspaceId, modelId: modelId || '', baseUrl: sgmDocsBaseUrl, authorizationHeader: tokenUsed, component }),
        'Get Model'
      ),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(tokenUsed) && Boolean(modelId) && (enableQuery !== undefined ? enableQuery : true),
    }
  );
}
